// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as CatalogueCardList from "./CatalogueCardList.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.paddingTop(BsCss.rem(1.5)),
      tl: {
        hd: BsCss.width(BsCss.pct(100.0)),
        tl: {
          hd: BsCss.paddingBottom(BsCss.rem(1.5)),
          tl: {
            hd: BsCss.media("(max-width: 768px)", {
                  hd: BsCss.paddingTop(BsCss.rem(0.5)),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var title = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.rem(2.0)),
      tl: {
        hd: BsCss.fontWeight({
              NAME: "num",
              VAL: 600
            }),
        tl: {
          hd: BsCss.paddingBottom(BsCss.rem(1.0)),
          tl: {
            hd: BsCss.media("(max-width: 768px)", {
                  hd: BsCss.fontSize(BsCss.rem(1.5)),
                  tl: {
                    hd: BsCss.paddingBottom(BsCss.rem(0.5)),
                    tl: /* [] */0
                  }
                }),
            tl: {
              hd: BsCss.media("(max-width: 480px)", {
                    hd: BsCss.fontSize(BsCss.rem(1.25)),
                    tl: /* [] */0
                  }),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles = {
  container: container,
  title: title
};

var make = React.memo(function (props) {
      return JsxRuntime.jsxs("div", {
                  children: [
                    props.showTitle ? JsxRuntime.jsx("h2", {
                            children: "Explore our eGift cards",
                            className: title
                          }) : null,
                    JsxRuntime.jsx(CatalogueCardList.make, {
                          catalogue: props.catalogue,
                          skuDict: Caml_option.some(Belt_Option.getWithDefault(props.skuDict, {}))
                        })
                  ],
                  className: container
                });
    });

var SkuPresentation;

export {
  SkuPresentation ,
  Styles ,
  make ,
}
/* container Not a pure module */
